import { useParams } from "react-router";

export const useCurrentCompanyId = () => {
  const { companyId } = useParams();
  if (!companyId) {
    throw new Error("Current company id not found");
  }

  return companyId;
};
